export default __webpack_public_path__ + "static/media/icon-edit.22e80074.svg";